<template>
<div class="manage-folder">
    <div class="title">
        <h1 class="">File Uploading</h1>
    </div>
    <ListOfFilesView @folder-open="OnFolderOpen" v-if="!hideListOfFilesView" :folder-name="FolderName" :success-message="successMessage" @update-success-message="updateSuccessMessage" :success-text="successText"  @close="closeSuccessMessage"/>
    <div v-else>
        <div class="search">
            <div class="paths" style="border: 1px solid #D05959">
                <label class="mdi mdi-folder" style="background-color: #D05959; color: #fff; margin: 0px; padding: 5px 10px 5px 10px"> : <span class="directory">Directory</span> </label>&nbsp;&nbsp;
                <div class="pathURL" style="display: flex; flex-wrap: wrap; align-content: center;">
                    <div style="inline" v-for="(path,idx) in absolutePath" :key="idx">
                        <div class="path" @click="navigate(path)">{{path.path}}/</div>
                    </div>
                </div>
            </div>
            <div class="createUploadBtns" style="display: flex; flex-wrap: wrap; align-content: center; width: 300px;">
                <div class="create-folder-button" @click="createFolder" v-if="this.permissions.includes('File-Access-Permission')">CREATE</div>
                <div class="upload-file-button" @click="openFileUploadModal" v-if="this.permissions.includes('File-Access-Permission')">UPLOAD</div>
            </div>
        </div>
        <div class="files-table">
            <table class="table">
                <tr v-for="data in folderDataList" :key="data">
                    <td class="file-row">

                        <div class="flex-nowrap">
                          <div style="flex: 0 0 5%">
                            <img class="folderImg" :src="folderImg" alt="">
                          </div>
                          <div class="fileNameContainer" style="flex: 0 0 70%">
                              <label class="fileName">{{ data['name'] }} </label>
                              <div class="country-icon-holder" v-if="data.regions.length != 8">
                                  <div v-for="(country, index) in showRegions(data.regions).sort()" :key="index">
                                      <img style="height:20px; width: 20px; margin-right: 5px; cursor:pointer;" :src="getImage(country)" :title="country" v-if="this.permissions.includes('File-Access-Permission')">
                                  </div>
                              </div>
                              <div class="country-icon-holder" v-else>
                                  <div>
                                      <img style="height:20px; width: 20px; margin-right: 5px; cursor:pointer;" :src="getImage('All')" title="all" v-if="this.permissions.includes('File-Access-Permission')">
                                  </div>
                              </div>
                          </div>
                        </div>
                        
                        <div class="btn-holder" style="flex: 0 0 25%">
                            <div class="button-holder">

                                <div class="edit-button-holder" @click="openSubFolder(data)">
                                    <!-- <label class="open-button">Open</label> -->
                                    <img :src="folderOpenIcon" class="open-folder-button" alt="">
                                </div>
                                <div class="edit-button-holder" @click="editFolderRegion(data)" v-if="this.permissions.includes('File-Access-Permission')">
                                    <img :src="editBtn" class="edit-button" alt="">
                                </div>
                                <div class="delete-button-holder" @click="deleteSubFolder(data)" v-if="this.permissions.includes('File-Access-Permission')">
                                    <img :src="deleteBtn" class="delete-button" alt="">
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
            <table class="table">
                <tr>
                    <td style="width:80%;padding:0px;">
                        <div class="files" v-for="(files,index) in fileDataList" :key="index">
                          <div class="flex-nowrap">
                            <div class="file-type-holder">
                                <img :src="pdfIcon" v-if="files.name.toLowerCase().endsWith('pdf')" class="fileImg" alt="">
                                <img :src="docxIcon" v-if="files.name.toLowerCase().endsWith('docx')" class="fileImg" alt="">
                                <img :src="docxIcon" v-if="files.name.toLowerCase().endsWith('doc')" class="fileImg" alt="">
                                <img :src="pngIcon" v-if="files.name.toLowerCase().endsWith('png')" class="fileImg" alt="">
                                <img :src="jpgIcon" v-if="files.name.toLowerCase().endsWith('jpg')" class="fileImg" alt="">
                                <img :src="jpegIcon" v-if="files.name.toLowerCase().endsWith('jpeg')" class="fileImg" alt="">
                                <img :src="xlsxIcon" v-if="files.name.toLowerCase().endsWith('xlsx')" class="fileImg" alt="">
                                <img :src="txtIcon" v-if="files.name.toLowerCase().endsWith('txt')" class="fileImg" alt="">
                                <img :src="pptIcon" v-if="files.name.toLowerCase().endsWith('ppt')" class="fileImg" alt="">
                                <img :src="pptIcon" v-if="files.name.toLowerCase().endsWith('pptx')" class="fileImg" alt="">
                                <img :src="csvIcon" v-if="files.name.toLowerCase().endsWith('csv')" class="fileImg" alt="">
                                <img :src="zipIcon" v-if="files.name.toLowerCase().endsWith('zip')" class="fileImg" alt="">
                            </div>
                            <div class="font-weight-bold file-Name">
                              <label class="fileName">{{files.name}}</label>
                              <label class="fileName" v-if="files.viewerUserId">Viewer: {{getViewerName(files.viewerUserId)}}</label>
                              <div class="country-icon-holder" v-if="files.regions.length != 8">
                                  <div v-for="(country, index) in showRegions(files.regions).sort()" :key="index">
                                      <img style="height:20px; width: 20px; margin-right: 5px; cursor:pointer;" :src="getImage(country)" :title="country" v-if="this.permissions.includes('File-Access-Permission')">
                                  </div>
                              </div>
                              <div class="country-icon-holder" v-else>
                                  <div>
                                      <img style="height:20px; width: 20px; margin-right: 5px; cursor:pointer;" :src="getImage('All')" title="all" v-if="this.permissions.includes('File-Access-Permission')">
                                  </div>
                              </div>
                            </div>
                          </div>
                            
                            <div class="button-holder">

                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('pdf') && getViewerName(files.viewerUserId) == null" @click="openDocument(formatPreviewData(files))">
                                    <!-- <button type="button" v-if="files.name.toLowerCase().endsWith('pdf')" class="btn btn-sm mt-2 previewBtn" @click="openDocument(formatPreviewData(files))">Preview</button> -->
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('txt') && getViewerName(files.viewerUserId) == null" @click="openText(formatPreviewData(files))">
                                    <!-- <button type="button" v-if="files.name.toLowerCase().endsWith('txt')" class="btn btn-sm mt-2 previewBtn" @click="openText(formatPreviewData(files))">Preview</button> -->
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('png') || files.name.toLowerCase().endsWith('jpg') || files.name.toLowerCase().endsWith('jpeg') && getViewerName(files.viewerUserId) == null" @click="openImage(formatPreviewData(files))">
                                    <!-- <button type="button" v-if="files.name.toLowerCase().endsWith('png') || files.name.toLowerCase().endsWith('jpg') || files.name.toLowerCase().endsWith('jpeg')" class="btn  btn-sm mt-2 previewBtn" @click="openImage(formatPreviewData(files))">Preview</button> -->
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="edit-button-holder" @click="editFileRegion(files)" v-if="this.permissions.includes('File-Access-Permission')">
                                    <img :src="editBtn" class="edit-button" alt="">
                                </div>
                                <div class="download-button-holder" @click="downloadFile(files)">
                                    <img :src="downloadBtn" class="download-button" alt="">
                                </div>
                                <div class="delete-button-holder" @click="deleteFile(activeFolder,files)" v-if="this.permissions.includes('File-Access-Permission')">
                                    <img :src="deleteBtn" class="delete-button" alt="">
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!-- Preview -->
        <div class="preview" v-if="active">
            <div class="viewer-overlay"></div>
            <div class="pdf-background" v-if="pdfView"></div>
            <div class="" :class="`${pdfView ? 'close-btn' : 'close-btn1'}`">
                <button type="button" class="btn btn-sm close-button" @click="close()">
                    <span class="mdi mdi-close-circle cancel"></span>
                </button>
            </div>

            <div class="pdf-holder" v-if="pdfView">
                <div class="doc-loader" v-if="docLoading"></div>
                <div class="pdf-topbar">
                    <div class="page-navigation">
                        <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('first')">
                            First Page
                        </button>
                        <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('previous')">
                            <div class=" nav-icon mdi mdi-menu-left"></div>
                        </button>
                        <label class="page-index">{{currentPage}}/{{numPages}}</label>
                        <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('next')">
                            <div class=" nav-icon mdi mdi-menu-right"></div>
                        </button>
                        <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('last')">
                            Last Page
                        </button>
                    </div>
                </div>
                <div class="pdf-viewer-holder">
                    <pdf class="pdf-viewer" :src="pdfFile" :page="currentPage" :resize="true" />
                </div>
            </div>

            <div v-if="imgView">
                <div class="image-holder">
                    <img class="image" :src="imgFile" alt="">
                    <div class="image-loader" v-if="imageLoading"></div>
                </div>
            </div>

            <div v-if="txtView">
                <div class="text-holder">
                    <object class="text-container" :data="txtFile"></object>
                    <div class="text-loader" v-if="textLoading"></div>
                </div>
            </div>
        </div>

        <!-- Upload File Modal -->
        <div v-if="showFileUploadModal" class="modal">
            <div class="background" @click="closeFileUploadModal"></div>
            <div class="file-modal-upload">
                <div class="modal-header">
                    <h2 class="modal-title">Upload File</h2>
                    <span class="close" @click="closeFileUploadModal">&times;</span>
                </div>
                <div class="modal-body">
                    <div class="folder-name-holder">
                        <label>Upload file:</label>
                        <input type="file" id="content" @change="onFileChange" name="content" style="padding: 20px; width: 300px; border: black solid 1px; border-radius: 20px;" accept=".docx,.jpeg,.jpg,.png,.txt,.pdf,.xlsx,.ppt,.pptx,.csv,.zip">
                    </div>
                    <div class="selection-container">
                        <div class="selection-type">
                            <label style="padding: 10px;">View By:</label>
                            <div class="radio-container">
                                <label>
                                    <input type="radio" v-model="selectionType" value="region" @change="handleSelectionTypeChange">
                                    Region
                                </label>
                                <label>
                                    <input type="radio" v-model="selectionType" value="employee" @change="handleSelectionTypeChange">
                                    Employee
                                </label>
                            </div>
                        </div>

                        <div class="selection-group" v-if="selectionType === 'region'">
                            <label style="padding: 10px;">Region</label>
                            <div class="checkbox-container">
                                <div style="display: flex; padding: 5px;">
                                    <input type="checkbox" id="region-all" value="all" v-model="allSelected" style="cursor:pointer;" @change="selectAllCountries">
                                    <label for="region-all">
                                        <img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage('All')" title="all" @change="selectAllCountries">
                                    </label>
                                </div>
                                <div v-for="(country, index) in countries" :key="index" style="display: flex; padding: 5px;">
                                    <input type="checkbox" :id="'region-' + country" :value="country" v-model="selectedFileCountries" style="cursor:pointer;" :disabled="allSelected">
                                    <label :for="'region-' + country"><img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage(country)" :title="country"></label>
                                </div>
                            </div>
                        </div>
                        
                        <div class="selection-group" v-if="selectionType === 'employee'">
                            <label style="padding: 10px;">Employee</label>
                            <div class="select-container">
                                <select v-model="selectedEmployee" class="employee-select">
                                    <option value="">Select an employee</option>
                                    <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                        {{ employee.name }} - {{employee.employee_id}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer">
                    <button class="submit-button" type="button" @click="submitFileSelections('upload')">Submit</button>
                </div>
            </div>
        </div>

        <!-- Edit File Modal -->
        <div v-if="showModal" class="modal">
            <div class="background" @click="closeModal"></div>
            <div class="file-modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Edit File Access</h2>
                    <span class="close" @click="closeModal">&times;</span>
                </div>
                <div class="modal-body">
                    <div class="current-selections" v-if="getfileID">
                        <div class="selection-info">
                            <h4>Current Access Settings</h4>
                            <div class="info-item" v-if="currentViewer">
                                <strong>Viewer:</strong> {{ getViewerName(currentViewer) }}
                            </div>
                            <div class="info-item" v-if="currentRegions.length">
                                <strong>Regions:</strong>
                                <div class="region-icons">
                                    <img v-for="region in currentRegions" 
                                         :key="region" 
                                         :src="getImage(region)" 
                                         :title="region"
                                         style="height:20px; width: 20px; margin-right: 5px;">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="selection-type">
                        <label style="padding: 10px;">Update Access By:</label>
                        <div class="radio-container">
                            <label>
                                <input type="radio" v-model="selectionType" value="region" @change="handleSelectionTypeChange">
                                Region
                            </label>
                            <label>
                                <input type="radio" v-model="selectionType" value="employee" @change="handleSelectionTypeChange">
                                Employee
                            </label>
                        </div>
                    </div>

                    <div class="selection-group" v-if="selectionType === 'region'">
                        <label style="padding: 10px;">Region</label>
                        <div class="checkbox-container">
                            <div style="display: flex; padding: 5px;">
                                <input type="checkbox" id="region-all" value="all" v-model="allSelected" style="cursor:pointer;" @change="selectAllCountries">
                                <label for="region-all">
                                    <img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage('All')" title="all" @change="selectAllCountries">
                                </label>
                            </div>
                            <div v-for="(country, index) in countries" :key="index" style="display: flex; padding: 5px;">
                                <input type="checkbox" :id="'region-' + country" :value="country" v-model="selectedFileCountries" style="cursor:pointer;" :disabled="allSelected">
                                <label :for="'region-' + country"><img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage(country)" :title="country"></label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="selection-group" v-if="selectionType === 'employee'">
                        <label style="padding: 10px;">Employee</label>
                        <div class="select-container">
                            <select v-model="selectedEmployee" class="employee-select">
                                <option value="">Select an employee</option>
                                <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                    {{ employee.name }} - {{employee.employee_id}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="submit-button" @click="submitFileSelections('edit')">Submit</button>
                </div>
            </div>
        </div>

        <!-- Folder Edit Modal -->
        <div v-if="showFolderModal" class="modal">
            <div class="background" @click="closeFolderModal"></div>
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Edit Folder</h2>
                    <span class="close" @click="closeFolderModal">&times;</span>
                </div>
                <div class="modal-body">
                    <div class="folder-name-holder">
                        <label>Folder Name:</label>
                        <input type="text" v-model="editFolderName" maxlength="40">
                    </div>
                    <!-- <label>Region:</label> -->
                    <label style="padding: 10px;"></label>
                    <div class="checkbox-container">
                        <div style="display: flex; padding: 5px;"><input type="checkbox" id="region-all" value="all" v-model="allSelected" style="cursor:pointer;" @change="selectAllCountries">
                            <label for="region-all">
                                <img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage('All')" title="all" @change="selectAllCountries">
                            </label>
                        </div>
                        <div v-for="(country, index) in countries" :key="index" style="display: flex; padding: 5px;">
                            <input type="checkbox" :id="'region-' + country" :value="country" v-model="selectedFolderCountries" style="cursor:pointer;" :disabled="allSelected">
                            <label :for="'region-' + country"><img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage(country)" :title="country"></label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="submit-button" @click="submitFolderSelections">Submit</button>
                </div>
            </div>
        </div>

        <!-- Folder Create Modal -->
        <div v-if="showCreateFolderModal" class="modal">
            <div class="background" @click="closeFolderCreateModal"></div>
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Create Folder</h2>
                    <span class="close" @click="closeFolderCreateModal">&times;</span>
                </div>
                <div class="modal-body">
                    <div class="folder-name-holder">
                        <label>Folder Name:</label>
                        <input type="text" v-model="createFolderName" maxlength="40">
                    </div>
                    <!-- <label>Region:</label> -->
                    <label style="padding: 10px;"></label>
                    <div class="checkbox-container">
                        <div style="display: flex; padding: 5px;"><input type="checkbox" id="region-all" value="all" v-model="allSelected" style="cursor:pointer;" @change="selectAllCountries">
                            <label for="region-all">
                                <img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage('All')" title="all" @change="selectAllCountries">
                            </label>
                        </div>
                        <div v-for="(country, index) in countries" :key="index" style="display: flex; padding: 5px;">
                            <input type="checkbox" :id="'region-' + country" :value="country" v-model="selectedFolderCountries" style="cursor:pointer;" :disabled="allSelected">
                            <label :for="'region-' + country"><img style="height:40px; width: 40px; margin-left: 5px; cursor:pointer;" :src="getImage(country)" :title="country"></label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="submit-button" @click="submitFolderSelections('create')">Submit</button>
                </div>
            </div>
        </div>

        <div class="loader" v-if="loading"></div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import {
    decryptData
} from '../js/utils/encrypt';
// import folderImg from '../assets/folder.svg';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ListOfFilesView from './ListOfFilesView.vue';
import deleteBtn from '../assets/Delete_btn.png';
import downloadBtn from '../assets/download-btn.png';
import editBtn from '../assets/edit-icon.png';
import docxIcon from '../assets/docx-icon.png';
import jpegIcon from '../assets/jpeg-icon.png';
import jpgIcon from '../assets/jpg-icon.png';
import pngIcon from '../assets/png-icon.png';
import txtIcon from '../assets/text-icon.png';
import pdfIcon from '../assets/pdf-icon.png';
import xlsxIcon from '../assets/excel-icon.png';
import pptIcon from '../assets/ppt-icon.png';
import csvIcon from '../assets/csv-icon.png';
import zipIcon from '../assets/zip-icon.png';
import pdfvuer from 'pdfvuer';
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';
import folderOpenIcon from '../assets/folder-open.png';
import previewIcon from '../assets/preview-icon.png';
import folderImg from '../assets/folder.svg';

export default {
    data() {
        return {
            folderOpenIcon: folderOpenIcon,
            previewIcon: previewIcon,
            folderImg: folderImg,
            deleteBtn: deleteBtn,
            downloadBtn: downloadBtn,
            docxIcon: docxIcon,
            jpegIcon: jpegIcon,
            jpgIcon: jpgIcon,
            pngIcon: pngIcon,
            txtIcon: txtIcon,
            pdfIcon: pdfIcon,
            pptIcon: pptIcon,
            csvIcon: csvIcon,
            zipIcon: zipIcon,
            xlsxIcon: xlsxIcon,
            editBtn: editBtn,
            search: '',
            hideListOfFilesView: false,
            loading: false,
            FolderName: '',
            FolderID: '',
            employeeId: '',
            filesList: '',
            activeFolder: '',
            subFolder: '',
            showModal: false,
            showFolderModal: false,
            countries: ['Australia', 'China', 'India', 'Singapore', 'Malaysia', 'Hong Kong', 'Philippines', 'Japan'],
            selectedFileCountries: [],
            selectedFolderCountries: [],
            selectedEmployee: '',
            employees: [],
            getfileID: '',
            permissions: [],
            pdfFile: this.pdfFile || '/example.pdf',
            imgFile: this.imgFile || '../assets/loading.gif',
            active: false,
            numPages: 0,
            currentPage: 1,
            pdfdata: undefined,
            pdfView: false,
            imgView: false,
            txtView: false,
            imageLoading: false,
            textLoading: false,
            docLoading: false,
            txtFile: this.txtFile || '/example.txt',
            all: all,
            australia: australia,
            china: china,
            hongkong: hongkong,
            india: india,
            japan: japan,
            malaysia: malaysia,
            philippines: philippines,
            singapore: singapore,
            absolutePath: [],
            folder: [],
            files: [],
            getfolderID: '',
            editFolderName: '',
            allSelected: false,
            showCreateFolderModal: false,
            createFolderName: '',
            showFileUploadModal: false,
            fileUploadContent: null,
            subFolderData: [],
            successMessage: false,
            successText: '',
            selectionType: '',
            viewerUsers: {},
            currentViewer: null,
            currentRegions: [],
        };
    },
    components: {
        ListOfFilesView,
        pdf: pdfvuer
    },
    computed: {
        disableCheckboxes() {
            return this.allSelected;
        },
        fileDataList() {
            if (this.activeFolder != null) {
                var refined = this.activeFolder.files[0];
            }
            return refined;
        },
        folderDataList() {
            if (this.activeFolder != null) {
                var subFolderData = this.activeFolder.subfolders;
            }
            return subFolderData;
        }
    },
    mounted() {
        var encryptedEmployeeID = localStorage.getItem('EmployeeID');
        const secretKey = process.env.KEY || 'myscecretkey';
        //Decrypting Permissions
        let mkLocalData = localStorage.getItem('Permissions');
        if (!mkLocalData) {
            mkLocalData = 'null';
        }
        this.permissions = decryptData(mkLocalData, secretKey);
        if (encryptedEmployeeID != null) {
            this.employeeId = decryptData(encryptedEmployeeID, secretKey).replace(/['"]+/g, '');
        }
        let folderPath = this.FolderName;
          axios.get(this.$hostName +`/folders/${folderPath}`).then(response => {
            this.filesList = response.data;
          });

        axios.get(this.$hostName + '/folders/base').then((response) => {
            var folderData = response.data.data.folder;
            var fileData = response.data.data.files;
            folderData.forEach((element) => {
                this.folder.push(element);
            });
            fileData.forEach((element) => {
                this.files.push(element);
            });
        });

    },
    methods: {
        updateSuccessMessage(message) {
            this.successMessage = message;
        },
        closeSuccessMessage(value){
            this.successMessage = value
        },
        reloadComponent() {
            this.absolutePath = [];
            this.successMessage = true;

            this.hideListOfFilesView = false;
            this.loading = false;
        },
        onFileChange(event) {
            this.fileUploadContent = event.target.files[0];
        },
        deleteSubFolder(data) {
            Swal.fire({
                text: 'Deleting this folder will delete all the subfolders and files. Are you sure you want to delete this folder?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: 'mr-2',
                    cancelButton: 'ml-2',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    var absPath = this.absolutePath.slice(1).map(obj => obj.path).join('/');

                    axios.post(this.$hostName + '/folders/delete', {
                            id: data.id,
                            filePath: absPath+'/'+data.name
                        })
                        .then((response) => {
                            this.loading = true;
                            console.log(response.data);
                        })
                        .catch((error) => {
                            console.error(error);
                        }).finally(() => {
                            this.successText = 'Folder deleted successfully!';
                            this.reloadComponent();
                        });
                }
            });
        },
        showRegions(regions) {
            var regionArr = [];
            regions.forEach(element => {
                regionArr.push(element.name);
            });
            return regionArr;
        },
        getImage(country) {
            switch (country) {
                case 'Australia':
                    return this.australia;
                case 'India':
                    return this.india;
                case 'China':
                    return this.china;
                case 'Hong Kong':
                    return this.hongkong;
                case 'Singapore':
                    return this.singapore;
                case 'Philippines':
                    return this.philippines;
                case 'Malaysia':
                    return this.malaysia;
                case 'Japan':
                    return this.japan;
                case 'All':
                    return this.all;
            }
        },
        createFolder() {
            this.createFolderName = '';
            this.allSelected = false;
            this.openFolderCreateModal();
        },
        formatPreviewData(data) {
            var finalFormat = {
                foldername: this.FolderName,
                filename: data.name
            };
            return finalFormat;
        },
        imageLoad() {
            return this.imgFile;
        },
        close() {
            this.active = false;
            this.pdfView = false;
            this.imgView = false;
            this.txtView = false;
            this.currentPage = 1;
            this.imgFile = '';
        },
        openImage(data) {
            this.imageLoading = true;
            this.imgView = true;
            this.active = true;
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.imgFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.imgView = true;
                this.imageLoading = false;
            });
        },
        openText(data) {
            this.textLoading = true;
            this.txtView = true;
            this.active = true;
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.txtFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.txtView = true;
                this.textLoading = false;
            });
        },
        openDocument(data) {
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            this.active = true;
            this.docLoading = true;
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.pdfFile = fileURL;
                var self = this;
                self.pdfdata = pdfvuer.createLoadingTask(fileURL);
                self.pdfdata.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                this.pdfView = true;
            }).finally(() => {
                this.docLoading = false;
            });
        },
        changePage(type) {
            if (type == 'next') {
                if (this.currentPage < this.numPages)
                    this.currentPage = this.currentPage + 1;
            } else if (type == 'previous') {
                if (this.currentPage > 1)
                    this.currentPage = this.currentPage - 1;
            } else if (type == 'first') {
                this.currentPage = 1;
            } else if (type == 'last') {
                this.currentPage = this.numPages;
            }
        },
        getImgUrl(filename) {
            try {
                return require(`C:/ProgramData/Scala/hrm-portal/assets/employee/pics/${filename}`);
            } catch (_) {
                return require('../assets/imagealt.png');
            }
        },
        deleteFile(activeFolder, file) {
            Swal.fire({
                text: 'Are you sure you want to delete this file?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: 'mr-2',
                    cancelButton: 'ml-2',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    var filePath = activeFolder.name + '/' + file.name;
                    this.loading = true;
                    axios.post(this.$hostName + '/files/delete', {
                            id: file.id,
                            folderId: activeFolder.id,
                            filePath: filePath,
                        })
                        .then(() => {
                            this.successText = 'File deleted successfully!';
                            this.reloadComponent();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });

        },
        openModal() {
            this.showModal = true;
        },
        openFolderModal() {
            this.showFolderModal = true;
        },
        openFolderCreateModal() {
            this.showCreateFolderModal = true;
            this.selectedFolderCountries = [];
            this.allSelected = false;
        },
        openFileUploadModal() {
            this.showFileUploadModal = true;
            this.selectedFileCountries = [];
            this.selectedEmployee = '';
            this.allSelected = false;
            
            // Fetch employees
            if(this.employees.length == 0){
                axios.get(this.$hostName + '/employeelistforleaveadjust')
                .then(response => {
                    this.employees = response.data.users;
                })
                .catch(error => {
                    console.error('Error fetching employees:', error);
                });
            }
        },
        // Closes modal
        closeModal() {
            this.showModal = false;
        },
        closeFolderModal() {
            this.showFolderModal = false;
        },
        closeFolderCreateModal() {
            this.showCreateFolderModal = false;
        },
        closeFileUploadModal() {
            this.showFileUploadModal = false;
        },
        submitFileSelections(type) {
            if (type == 'upload') {
                const pathArray = this.absolutePath.slice(1).map(obj => obj.path);
                const pathString = pathArray.join('/');
                this.UploadFile(this.fileUploadContent, this.employeeId, pathString, this.selectedFileCountries);
            } else {
                if (!this.selectionType) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please upload a file and select a type (Region or Employee).',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    });
                } else if (this.selectionType === 'region' && this.selectedFileCountries.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please select at least one region.',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    });
                } else if (this.selectionType === 'employee' && !this.selectedEmployee) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please select an employee.',
                        confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        });
                } else {
                    this.showModal = false;
                    this.loading = true;
                    axios.post(this.$hostName + '/files/update', {
                            file_id: this.getfileID,
                            region_names: this.selectedFileCountries,
                            viewerUserId: this.selectedEmployee
                        })
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                        this.successText = 'File updated successfully!';
                        this.reloadComponent();
                    });
                }
            }
        },
        submitFolderSelections(type) {
            if (type == 'create') {
                var absPath = this.absolutePath.slice(1).map(obj => obj.path).join('\\');
                if (this.createFolderName === '' || this.selectedFolderCountries.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please enter a folder name and select at least one country.',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    });
                } else {
                    this.showCreateFolderModal = false;
                    this.loading = true;
                    axios.post(this.$hostName + '/folders/createSubFolder', {
                            name: this.createFolderName,
                            regions: this.selectedFolderCountries,
                            parent_id: this.FolderID,
                            path: absPath
                        })
                        .then(response => {
                            if (response.status == 203) {
                                this.loading = false;
                                Swal.fire({
                                    icon: 'warning',
                                    text: response.data.message,
                                    confirmButtonText: 'Ok'
                                });
                            } else {
                                this.successText = 'Folder created successfully!';
                            this.reloadComponent();
                            }
                        })
                        .catch(error => {
                            console.log(error.response.data.message); // Error message
                        });

                }
            } else {
                this.showFolderModal = false;
                this.loading = true;
                axios.post(this.$hostName + '/folder/update', {
                        id: this.getfolderID,
                        region_names: this.selectedFolderCountries,
                        name: this.editFolderName
                    })
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                        this.successText = 'Folder updated successfully!';
                        this.reloadComponent();
                    });
            }
        },
        editFileRegion(data) {
            this.allSelected = false;
            this.getfileID = data.id;
            this.selectedFileCountries = [];
            this.currentViewer = data.viewerUserId;
            this.currentRegions = [];
            this.selectionType = data.viewerUserId ? 'employee' : 'region'; // Set selection type based on current viewer
            this.selectedEmployee = data.viewerUserId;
            this.openModal();
            
            // Fetch current regions
            axios.get(this.$hostName + `/files/${data.id}/regions`)
                .then(response => {
                    if (Object.keys(response.data.region).length == 8) {
                        this.allSelected = true;
                    }
                    // Handle successful response
                    for (let country in response.data.region) {
                        this.selectedFileCountries.push(response.data.region[country]);
                        this.currentRegions.push(response.data.region[country]);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        selectAllCountries(event) {
            if (event.target.checked) {
                // Select all countries
                this.selectedFolderCountries = [...this.countries];
                this.selectedFileCountries = [...this.countries];
            } else {
                // Deselect all countries
                this.selectedFolderCountries = [];
                this.selectedFileCountries = [];
            }
        },
        editFolderRegion(data) {
            this.allSelected = false;
            this.getfolderID = data.id;
            this.selectedFolderCountries = [];
            this.openFolderModal();
            axios.get(this.$hostName + `/folder/${data.id}/data`)
                .then(response => {
                    this.editFolderName = response.data.name;
                    if (Object.keys(response.data.region).length == 8) {
                        this.allSelected = true;
                    }
                    // Handle successful response (e.g. update component data)
                    for (let country in response.data.region) {
                        this.selectedFolderCountries.push(response.data.region[country]);
                    }
                })
                .catch(error => {
                    // Handle error (e.g. show error message)
                    console.error(error);
                });
        },
        downloadFile(fileData) {
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            let path = finalPath + '/' + fileData.name;
            var formData = {
                filePath: path
            };
            axios({
                url: this.$hostName + '/files/downloadAll',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                var fileName = fileData.name;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
            });
        },
        UploadFile(file, empId, folderPath, regions) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('empId', empId);
            formData.append('folderPath', folderPath);
            formData.append('regions', regions);
            
            if (this.selectedEmployee) {
                formData.append('viewerUserId', this.selectedEmployee);
            }
            
            if (file === null || (!this.selectionType)) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please upload a file and select a type (Region or Employee).',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                });
            } else if (this.selectionType === 'region' && regions.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please select at least one region.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                });
            } else if (this.selectionType === 'employee' && !this.selectedEmployee) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please select an employee.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                });
            } else {
                this.showFileUploadModal = false;
                this.loading = true;
                axios.post(this.$hostName + `/folders/${this.FolderID}/upload`, formData)
                    .then((response) => {
                        if (response.status == 202) {
                            const validFileTypes = ['pdf', 'docx', 'jpg', 'jpeg', 'png', 'zip', 'ppt', 'xlsx', 'csv', 'txt'];
                            this.loading = false;
                            Swal.fire({
                                icon: 'warning',
                                title: 'Invalid File Type!',
                                text: `The selected file type is not allowed. Please select a valid file type from ${validFileTypes.join(', ')}.`,
                                confirmButtonText: 'OK'
                            });
                        } else if (response.data.confirm) {
                            this.loading = false;
                            Swal.fire({
                                title: 'Are you sure?',
                                text: response.data.message,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, replace it!',
                                cancelButtonText: 'No, cancel',
                                customClass: {
                                    confirmButton: 'mr-2',
                                    cancelButton: 'ml-2',
                                }
                            }).then(result => {
                                if (result.isConfirmed) {
                                    formData.append('replace', true);
                                    formData.append('id', response.data.fileid);
                                    this.UploadFileConfirmed(formData);
                                } else {
                                    this.loading = false;
                                    Swal.fire(
                                        'Cancelled',
                                        'File replacement cancelled by user',
                                        'error'
                                    );
                                }
                            });
                        } else {
                            this.successText = 'File updated successfully!';
                            this.reloadComponent();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },
        UploadFileConfirmed(formData) {
            this.loading = true;
            axios.post(this.$hostName + '/files/replace', formData)
                .then(response => {
                    console.log(response.data); // Handle the confirmed success response here
                })
                .catch(error => {
                    console.error(error); // Handle the confirmed error response here
                }).finally(() => {
                    this.successText = 'File uploaded successfully!';
                    this.reloadComponent();
                });
        },
        closeFolder() {
            this.hideListOfFilesView = false;
            this.absolutePath = [];
        },
        OnFolderOpen(folderOpen, data) {
            this.subFolderData = data;
            var pathdata = {
                path: 'root',
                data: this.folder
            };
            this.absolutePath.push(pathdata);
            this.hideListOfFilesView = folderOpen;
            this.FolderName = data.name;
            pathdata = {
                path: this.FolderName,
                data: data
            };
            this.absolutePath.push(pathdata);
            this.FolderID = data.id;
            this.activeFolder = data;
        },
        navigate(data) {
            this.FolderName = data.path;
            if (data.path == 'root') {
                this.hideListOfFilesView = false;
                this.absolutePath = [];
            } else {
                for (let i = 0; i < this.absolutePath.length; i++) {
                    if (this.absolutePath[i].path == data.path) {
                        for (let j = i; j < this.absolutePath.length; j++) {
                            this.absolutePath.splice(j, this.absolutePath.length);
                            break;
                        }
                    }
                }

                this.openSubFolder(data.data);
            }
        },
        openSubFolder(data) {
            var pathdata = {
                path: data.name,
                data: data
            };
            this.absolutePath.push(pathdata);
            this.FolderName = data.name;
            this.FolderID = data.id;
            this.FolderID = data.id;
            this.activeFolder = data;
        },
        searchFiles(fileList) {
            if (!this.search) return fileList;
            return fileList.filter((file) => {
                return (
                    file['filename']
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toString().toLowerCase())
                );
            });
        },
        updatefilter(event) {
            this.filter = event.target.value;
        },
        sortFiles(fileList) {
            return fileList.sort((a, b) => {
                if (a[1] < b[1]) return -1;
                if (a[1] > b[1]) return 1;
                return 0;
            });
        },
        handleRegionSelection() {
            if (this.selectedFileCountries.length > 0) {
                this.selectedEmployee = ''; // Clear employee selection when regions are selected
            }
        },
        
        handleEmployeeSelection() {
            if (this.selectedEmployee) {
                this.selectedFileCountries = []; // Clear region selection when employee is selected
                this.allSelected = false;
            }
        },
        handleSelectionTypeChange() {
            // Clear both selections when switching types
            this.selectedFileCountries = [];
            this.selectedEmployee = '';
            this.allSelected = false;
        },
        getViewerName(viewerId) {
          
            if(this.employees.length == 0){
                 // Fetch employees
                 axios.get(this.$hostName + '/employeelistforleaveadjust')
                 .then(response => {
                     this.employees = response.data.users;
                 })
                 .catch(error => {
                     console.error('Error fetching employees:', error);
                 });
             }

            if(viewerId == null){
                return null;
            }   
            if (this.viewerUsers[viewerId]) {
                return this.viewerUsers[viewerId];
            }

            // Fetch employees
            axios.get(this.$hostName + '/employees/list')
            .then(response => {
                
                // Create a mapping of user IDs to names
                this.viewerUsers = response.data.users.reduce((acc, user) => {
                    acc[user.id] = user.name + ' - ' + user.employee_id;
                    return acc;
                }, {});

            })
            .catch(error => {
                console.error('Error fetching employees:', error);
            });            
            return this.viewerUsers[viewerId] || viewerId;
        },
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 575.98px) {
    .create-folder-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }

    .files-table {
        height: 79vh !important;
    }

    .pdf-background {
        z-index: -1;
    }

    .previewBtn {
        left: 10px;
        position: initial !important;
        margin-top: 20px;
        height: 6%;
        width: 100%;
        margin-top: 4px !important;
    }

    .btn-holder {
        float: right;
    }

    .nav-button {
        font-size: 12px;
    }

    .pdf-topbar {
        width: 96% !important;
        height: 54px;
        position: absolute;
        top: 140px !important;
        left: calc(50%) !important;
        transform: translate(-50%) !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .page-navigation {
        width: 100% !important;
        color: black !important;
        flex-wrap: nowrap !important;
        align-items: center;

        button {
          font-size: 14px;
          overflow-y: hidden;
        }
    }

    .pdf-viewer {
        left: calc(50%) !important;
        top: 423px !important;
        width: 300px !important;
    }

    .image-holder {
        left: calc(50%) !important;
    }

    .text-holder {
        background-color: white;
        left: calc(50%) !important;
        width: 80% !important;
        height: 80% !important;
    }

    .close-btn {
        position: absolute;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;

        .close-button {
          height: 40px;
          width: 40px;
        }
    }

    .close-btn1 {
        position: absolute !important;
        top: 226px !important;
        left: 85% !important;

        .close-button {
          height: 40px;
          width: 40px;
        }
    }

    .cancel {
        font-size: 45px !important;
        color: #d82d28;
        position: absolute;
        top: 50%;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .search {
      flex-direction: column;
      white-space: nowrap;
      width: 95% !important;
    }

    .paths {
      width: 95% !important;

      .pathURL {
        flex-wrap: nowrap !important;
        max-width: 250px;
        align-items: center;
        overflow-x: auto;
        padding-top: 15px;

        .path {
          // width: 150%;
        }
      }

      label {
        padding-top: 10px !important;
        width: 54px;
      }
    }

    .fileImg {
      width: 30px !important;
      height: unset !important;
    }

    .folderImg {
      width: 30px !important;
      height: unset !important;
    }

    .file-Name, .fileName {
      font-size: 14px !important;
      margin-left: 8px;
    }

    .fileNameContainer {
      flex: 0 0 80% !important;
    }

    .fileName {
      padding-left: 8px !important;
    }

    .file-row {
      .country-icon-holder {
        padding-left: 8px !important;
      }
    }

    .files, .file-row {
      padding: 10px !important;
      height: auto !important;
    }

    .preview-button {
      height: 14px !important;
      width: 21px !important;
    }

    .edit-button, .download-button, .delete-button {
      height: 16px !important;
      width: 14px !important;
    }

    .open-folder-button {
      height: 15px !important;
      width: 20px !important;
    }

    .edit-button-holder, .download-button-holder, .delete-button-holder {
      width: 40px !important;
      height: 30px !important;
    }

    .button-holder, .btn-holder {
      margin-top: 10px;
      margin-left: auto;
    }

    .btn-holder {
      margin-top: unset;
    }

    .upload-file-button {
      margin-left: 10px;
    }

    .pathURL {
      font-size: 14px;
    }

    .createUploadBtns {
      padding-top: 10px;
      margin-left: -14px;
    }

    .file-modal-content {
      height: 450px !important;
      width: 60% !important;
    }

    .modal-content, .file-modal-upload {
      height: 520px !important;
      width: 65% !important;
    }

    .modal-title {
      font-size: 20px;
    }

    #content {
      padding: 10px !important;
      width: 10px !important;
      border-radius: 5px !important;
    }

    .flex-nowrap {
      flex: 0 0 100% !important;
      display: flex;
      flex-wrap: nowrap !important;
    }

    .directory {
      display: none;
    }
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .close-btn1 {
        position: absolute !important;
        top: 36px !important;
    }

    .cancel {
        font-size: 40px !important;
        color: #d82d28;
        position: absolute !important;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .close-btn {
        position: absolute !important;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;
    }

    .pdf-background {
        z-index: -1;
    }

    .pdf-topbar {
        width: 70% !important;
        height: 48px !important;
        position: absolute;
        top: 140px !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .page-navigation {
        width: 100% !important;
        left: 50%;
        transform: translate(-50%);
        position: absolute;
        color: white;
        top: 8px !important;
    }

    .pdf-viewer {
        top: 600px !important;
        width: 500px !important;
    }

    .createUploadBtns, .files {
      flex-wrap: nowrap !important;
    }

    // .button-holder {
    //   margin-left: -90px !important;
    // }

    .btn-holder {
      // margin-left: -3px !important;
      // margin-right: 20px !important;
      flex: 0 0 35% !important;
    }

    .button-holder {
      flex: 0 0 35% !important;
    }

    .fileImg {
      width: 45px !important;
      height: 50px !important;
    }

    .fileNameContainer {
      flex: 0 0 80% !important;
    }

    .fileName {
      // font-size: 14px !important;
    }

    .file-row {
      flex-wrap: nowrap !important;
    }

    .file-Name {
      flex: 0 0 80% !important;
    }

    .file-modal-upload {
      height: 420px !important;
    }

    .file-modal-content {
      height: 360px !important;
    }

    #content {
      padding: 10px !important;
      border-radius: 5px !important;
    }

    .flex-nowrap {
      flex: 0 0 65% !important;
    }
}

.country-icon-holder {
    display: flex;
}

.checkbox-container {
    display: flex;
    flex-wrap: wrap;
}

.paths {
    margin-left: 2%;
    font-size: 20px;
    width: 100%;
    display: flex;
}

.path:hover {
    cursor: pointer;
}

.fileName {
    font-size: 18px;
    word-break: break-word;
    margin-right: 10px;
    
    &:last-child {
        color: #666;
        font-size: 14px;
    }
}

label {
    display: block;
    margin: 0;
}

.files-table {
    height: 82vh;
    overflow: auto;
    padding: 10px;
    font-size: 12px;
}

.folderImg {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}

.file-row {
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 100%;
    padding: 10px 20px;
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.button-holder {
    display: flex;
    justify-content: flex-end;

}

.open-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 90px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #DDE2FF;
    margin-left: 10px;
}

.open-button {
    color: #4E65FF;
    font-size: 16px;
}

.open-button-holder:active {
    transform: scale(0.9);
}

.open-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.open-button-holder:hover {
    cursor: pointer;
}

.open-button:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

.create-folder-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    margin-left: 20px;
    cursor: pointer;
}

.previewBtn {
    background-color: #EE3234;
    color: #fff;
    padding: 5px;
    margin-top: 0.2rem !important;
    margin-left: 10px;
}

.pdf-background {
    background-color: #505257;
    height: 97%;
    width: 36%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.image-loader {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    z-index: 999;
}
.text-loader{
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    z-index: 999;
}

.doc-loader {
    // background-color: rgba(0, 0, 0, 0.5);
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    backdrop-filter: blur(5px);
    z-index: 1;
}

.image-holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 90%;
}

.text-holder {
    position: absolute;
    top: 52%;
    left: 50%;
    background-color: white;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 90%;
}

.text-container {
    height: 100%;
    width: 100%;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain
}

.btn-holder {
    float: right;
    position: relative;
}

.nav-icon {
    font-size: 26px;
    position: relative;
    top: -10px;
}

.close-icon {
    font-size: 26px;
    position: relative;
    left: -7px;
    top: -9px;
}

.close-button {
    background-color: white;
    height: 20px;
    width: 20px;
    position: absolute;
    border-radius: 50%;
    padding: 0;
}

.cancel {
    font-size: 30px;
    color: #d82d28;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
}

.cancel:hover {
    color: #b60a04;
}

.nav-button {
    height: 30px;
}

.viewer-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    backdrop-filter: blur(5px);
}

.pdf-topbar {
    width: 32%;
    height: 40px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%);
    background-color: white;
    text-align: center;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
}

.pdf-viewer {
    width: 30%;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
}

.page-navigation {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    color: white;
    top: 4px;
}

.page-index {
    width: 60px;
    text-align: center;
    color: #000;
}

.close-btn {
    position: absolute;
    top: 4px;
    left: 67.5%;
    z-index: 999;
}

.close-btn1 {
    position: absolute;
    top: 8px;
    left: 90%;
    z-index: 999;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

.download-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.download-button-holder:active {
    transform: scale(0.9);
}

.download-button-holder {
    transition: transform 100ms ease-in-out;
}

.download-button-holder:hover {
    cursor: pointer;
}

.download-button {
    height: 30px;
    width: 20px;
}

.edit-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.edit-button-holder:active {
    transform: scale(0.9);
}

.edit-button-holder {
    transition: transform 100ms ease-in-out;
}

.edit-button-holder:hover {
    cursor: pointer;
}

.edit-button {
    height: 30px;
    width: 30px;
}

.preview-button {
    height: 20px;
    width: 30px;
}

.open-folder-button {
    height: 25px;
    width: 30px;
}

th {
    margin: 0;
}

tr {
    text-align: left;
}

td {
    text-align: left;
    vertical-align: baseline !important;
}

td:first-child {
    vertical-align: middle !important;
}

thead {
    top: 0;
    position: sticky;
}

table {
    border-collapse: separate;
    border-spacing: 0 10px;
}

.table {
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
}

table td {
    border-top: 0;
}

/* The Modal (background) */
.folder-name-holder {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    padding: 10px 0px;
}

.folder-name-holder input {
    flex: 0 75%;
}

.folder-name-holder label {
    flex: 0 25%;
    font-size: 14px;
}

.modal {
    display: flex;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content/Box */
.background {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
}

.modal-content {
    z-index: 3;
    height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

.file-modal-content {
    z-index: 3;
    height: 400px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 5% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
    background-color: white;
    max-height: 85vh;
    overflow-y: auto;
}

.file-modal-upload {
    z-index: 3;
    height: 520px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

/* The Close Button */
.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.modal-header {
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.modal-body {
    padding: 2px 16px;
    flex: 1;
    overflow-y: auto;
}

.modal-body label {
    font-size: 14px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.submit-button {
    padding: 10px 20px;
    background-color: #5cb85c;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
}

.submit-button:hover {
    background-color: #4CAF50;
}

.files {
    display: flex;
    align-items: center;
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: bold;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.file-Name {
    position: relative;
    flex: 0 0 70%;
    font-size: 16px;
}

.button-holder {
    flex: 0 0 25%;
    display: flex;
    justify-content: flex-end;
}

.fileImg {
    height: 40px;
    margin-right: 10px;
}

.file-type-holder {
    flex: 0 0 5%;
}

.flex-nowrap {
  display: flex;
  flex: 0 0 75%;
  align-items: center;
}

@media only screen and (max-width: 575.98px) {
    .fileName {
        font-size: 14px !important;
        margin: 0 !important;
    }

    .file-Name {

      flex: 0 0 75%;

      .fileName {
        padding-left: unset !important;
      }
    }

    .manage-folder {
        height: 100% !important;
    }

    .upload-file-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }
}

.swal2-popup {
    font-family: Arial, sans-serif;
}

/* Style for the checkboxes */
.swal2-checkboxes label {
    display: block;
    margin-bottom: 10px;
    color: #777;
}

.swal2-checkboxes input[type="checkbox"] {
    margin-right: 5px;
}

.back-btn {
    border: 1px solid #000000;
    border-radius: 50%;
    padding-left: 5px;
    padding-right: 5px;
}

.back-btn:hover {
    background-color: #626262;
    border: 1px solid #ffffff;
    color: #fff;
    cursor: pointer;

}

.upload-file-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    cursor: pointer;
}

.manage-folder {
    font-family: 'Montserrat';
    position: relative;
    padding-top: 1.5rem;
    height: 100vh;
    left: 60px;
    width: calc(100% - 60px);
    // overflow: hidden;
}

.icon {
    font-size: 25px;
}

.search {
    width: 97%;
    flex-grow: 1;
    height: 100%;
    position: relative;
    display: flex;
    margin-left: 2%;

    .icon {
        width: 40px;
        height: 100%;
        font-size: 24px;
        color: #000;
        // opacity: .5;
        position: relative;
        float: left;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    input {
        width: 220px;
        height: 100%;
        position: relative;
        float: left;
        font-size: 14px;
        -webkit-appearance: none;
        outline: 0;
        border-width: 0 0 2px;
        border-color: rgb(40, 40, 102);
        background-color: transparent;
        color: $general-black-light;
        flex-grow: 1;

        &::placeholder {
            opacity: 0.6;
            font-style: italic;
        }
    }
}

.selection-container {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}

.selection-group {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
}

.selection-group label {
    font-weight: bold;
    margin-bottom: 5px;
}

.checkbox-container {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;
    padding: 5px;
}

.radio-container {
    display: flex;
    gap: 20px;
    padding: 10px;
    
    label {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
        
        input[type="radio"] {
            cursor: pointer;
        }
    }
}

.selection-type {
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    
    label {
        font-weight: bold;
        margin-bottom: 5px;
    }
}

.current-selections {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 5px;
    border: 1px solid #ddd;
}

.file-modal-content {
    height: 600px !important;
    max-height: 80vh;
    overflow-y: auto;
}
</style>
